export default function () {
  $('.section-Policies-Business-integrity .accordionHeader[data-sectionid="5"]').addClass(
    "WhatAreSanctions"
  );
}
